function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var mainHeader = new (/*#__PURE__*/function () {
  function MainHeader() {
    _classCallCheck(this, MainHeader);
    document.addEventDelegate('NAV:OPEN', this.doNavOpen.bind(this));
    document.addEventDelegate('NAV:CLOSE', this.doNavClose.bind(this));
    document.addEventDelegate('NAV:ACTIVE_ITEM', this.onNavActiveItem.bind(this));
    document.addEventDelegate('APP:READY', this.init.bind(this));
  }
  return _createClass(MainHeader, [{
    key: "init",
    value: function init() {
      this.elts = {
        nav: document.querySelector('#main-nav'),
        links: document.querySelectorAll('#main-nav a'),
        toggles: document.querySelectorAll('[aria-controls="main-nav"]')
      };
      document.addEventDelegate('click', this.onNavToggleClick.bind(this), '[aria-controls="main-nav"]');
      document.addEventDelegate('click', this.onNavLinkClick.bind(this), '#main-nav a');
      document.addEventDelegate('keydown', this.onNavKeyDown.bind(this));
      window.addEventListener('resize', this.onResize.bind(this));
      window.addEventListener('scroll', this.onScroll.bind(this));
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      if (!window.lastScrollTop) {
        window.lastScrollTop = 0;
      }
      var st = window.scrollY;
      if (Math.abs(window.lastScrollTop - st) <= 80) return;
      if (st > 260) {
        document.body.classList.add('menu-sticky');
      } else {
        document.body.classList.remove('menu-sticky');
      }
      if (st < window.lastScrollTop || this.elts.nav.getAttribute('aria-hidden') === 'false') {
        document.body.classList.remove('scroll-down');
      } else {
        if (st > 260) {
          document.body.classList.add('scroll-down');
        } else {
          document.body.classList.remove('scroll-down');
        }
      }
      window.lastScrollTop = st;
    }
  }, {
    key: "onResize",
    value: function onResize() {
      // if (window.getComputedStyle(this.mainBurger).display === 'none') {
      //   this.elts.nav.removeAttribute('aria-hidden');
      // } else {
      //   this.elts.nav.setAttribute('aria-hidden', this.mainBurger.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      // }
    }
  }, {
    key: "onNavToggleClick",
    value: function onNavToggleClick(e) {
      var navClose = this.elts.nav.getAttribute('aria-hidden') === 'false';
      document.dispatchEventDelegate('NAV:' + (navClose ? 'CLOSE' : 'OPEN'));
    }
  }, {
    key: "onNavLinkClick",
    value: function onNavLinkClick(e) {
      document.dispatchEventDelegate('NAV:CLOSE');
    }
  }, {
    key: "onNavKeyDown",
    value: function onNavKeyDown(e) {
      if (e.key === 'Escape' && this.elts.nav.getAttribute('aria-hidden') === 'false') {
        document.dispatchEventDelegate('NAV:CLOSE');
      }
    }
  }, {
    key: "doNavOpen",
    value: function doNavOpen(e) {
      this.elts.nav.setAttribute('aria-hidden', 'false');
      this.elts.toggles.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });
      document.body.classList.add('is-main-nav-open');
      this.onResize();
    }
  }, {
    key: "doNavClose",
    value: function doNavClose(e) {
      this.elts.nav.setAttribute('aria-hidden', 'true');
      this.elts.toggles.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      document.body.classList.remove('is-main-nav-open');
      this.onResize();
    }
  }, {
    key: "onNavActiveItem",
    value: function onNavActiveItem(e) {
      this.elts.links.forEach(function (link) {
        link.classList.remove('is-active');
      });
      e.detail.current.classList.add('is-active');
    }
  }]);
}())();